// src/scripts/audits/venueAuditConfigs/zoo-watfordAudit.js

import { buildManagersOfficeSection } from "@/scripts/audits/shared/managersOfficeSection";

const venueSections = [
  {
    id: "outside",
    title: "Outside",
    icon: "store",
    items: [
      { key: "v1", label: "Shopfront Fasica Clean" },
      { key: "v2", label: "Windows Clean" },
      { key: "v3", label: "POS all in date" },
      { key: "v4", label: "All bulbs working" },
      { key: "v5", label: "Signage Working" },
      { key: "v6", label: "Correct Graphics & Signage" },
      { key: "v7", label: "Alarm Working" },
    ],
  },
  {
    id: "customerArea",
    title: "Customer Area",
    icon: "weekend",
    items: [
      { key: "v8", label: "Floor polished & clean" },
      { key: "v9", label: "Skirting clean with no polish build-up" },
      { key: "v10", label: "Tables <b>NOT</b> sticky" },
      { key: "v11", label: "No chewing gum" },
      { key: "v12", label: "Walls clean with no marks/scuffs" },
      { key: "v13", label: "Aircon Extract grills clean" },
      { key: "v14", label: "Door Frames" },
      { key: "v15", label: "Kick plates clean" },
      { key: "v16", label: "All Bulbs working" },
      { key: "v17", label: "Doors closing properly" },
      { key: "v18", label: "Bar-Top clean" },
      { key: "v19", label: "Bar front chewing gum free" },
      { key: "v20", label: "Beer Taps and complete" },
      { key: "v21", label: "POS in date" },
      { key: "v22", label: "Entrance desk tidy" },
      { key: "v23", label: "Tills marked correctly & draws Working" },
      { key: "v24", label: "All metal polished" },
      { key: "v25", label: "Staircase & Risers clean" },
      { key: "v26", label: "Fire Equipment in correct position" },
      { key: "v27", label: "All fixed seating clean & no rips" },
    ],
  },
  {
    id: "toiletsDisabled",
    title: "Toilets & Disabled",
    icon: "wc",
    items: [
      { key: "v28", label: "Hand dryers working" },
      { key: "v29", label: "Toilet papaer dispensers full & working" },
      { key: "v30", label: "Soap dispensers full" },
      { key: "v31", label: "Toilet blocks/pads present" },
      { key: "v32", label: "No Urine odour present" },
      { key: "v33", label: "Cubical locks working" },
      { key: "v34", label: "Toilets flush" },
      { key: "v35", label: "Floor Seats not broken" },
      { key: "v36", label: "Floor clean" },
      { key: "v37", label: "Taps working" },
      { key: "v38", label: "Urinals flush" },
      { key: "v39", label: "POS in date" },
      { key: "v40", label: "Walls clean with no marks" },
      { key: "v41", label: "Mirrors clean with no smears" },
      { key: "v42", label: "Tampon bins correct" },
      { key: "v43", label: "Lights working" },
      { key: "v44", label: "Hot water working" },
    ],
  },
  {
    id: "staffAreas",
    title: "Staff Areas & Toilets",
    icon: "badge",
    items: [
      { key: "v56", label: "Staff toilets clean" },
      { key: "v57", label: "Soap & Nail brushes present" },
      { key: "v58", label: "Toilet paper dispensers full & working" },
      { key: "v59", label: "Signage Up" },
      { key: "v60", label: "Floors & Walls clean" },
      { key: "v61", label: "Locks working" },
      { key: "v62", label: "Lights Working" },
      { key: "v63", label: "Lockers Tidy" },
      { key: "v64", label: "No Clutter" },
    ],
  },
  {
    id: "backOfHouse",
    title: "Back of House",
    icon: "inventory_2",
    items: [
      { key: "v51", label: "Bin area clean" },
      { key: "v52", label: "Area clean & tidy, free of clutter" },
      { key: "v53", label: "Heath & Safety poster displayed" },
      { key: "v54", label: "Promotional items stored correctly" },
      { key: "v55", label: "First-Aid boxes in correct locations & full" },
    ],
  },
  {
    id: "dj",
    title: "DJ Consul & Effects",
    icon: "graphic_eq",
    items: [
      { key: "v88", label: "CDJ's Working & Clean" },
      { key: "v89", label: "Tidy Area" },
      { key: "v90", label: "Mixer Working" },
      { key: "v91", label: "Surfaces Clean" },
      { key: "v92", label: "Sound equipment all working" },
      { key: "v93", label: "Lighting all working" },
      { key: "v94", label: "Lighting controllers working" },
    ],
  },
  {
    id: "cloakroom",
    title: "Cloakroom",
    icon: "checkroom",
    items: [
      { key: "v45", label: "Clean & Tidy" },
      { key: "v46", label: "No lost property" },
      { key: "v47", label: "Till draw working" },
      { key: "v48", label: "Correct button marking" },
      { key: "v49", label: "Enough hangers available" },
      { key: "v50", label: "Cloakroom tikcets on hangers" },
    ],
  },
  {
    id: "bars",
    title: "Bars",
    icon: "local_bar",
    items: [
      { key: "v65", label: "PDQ on charge & working" },
      { key: "v66", label: "Bar back clean & tidy" },
      { key: "v67", label: "Mirrors Polished" },
      { key: "v68", label: "TV Screens Clean" },
      { key: "v69", label: "Glasswear Clean" },
      { key: "v70", label: "Glasswear in correct order" },
      { key: "v71", label: "Shelving not sticky" },
      { key: "v72", label: "Correct Jiggers in Place" },
      { key: "v73", label: "No stickiness on dispense pumps" },
      { key: "v74", label: "No bar Fly" },
      { key: "v75", label: "Cling-film/Bottle covers in place" },
      { key: "v76", label: "All Spirits locked up" },
      { key: "v77", label: "Fridges stocked correctly" },
      { key: "v78", label: "Glasswash Empty" },
      { key: "v79", label: "No dirty glasses" },
      { key: "v80", label: "Floor clean & not sticky" },
      { key: "v81", label: "Lights Working" },
      { key: "v82", label: "Fridges working & clean" },
      { key: "v83", label: "Post-Mix calibrated" },
      { key: "v84", label: "Tills working" },
      { key: "v85", label: "Correct signage in place" },
      { key: "v86", label: "Price List up-to-date" },
      { key: "v87", label: "Measured 25ml pourers on site" },
    ],
  },
  {
    id: "cellar",
    title: "Cellar",
    icon: "warehouse",
    items: [
      { key: "v95", label: "Spirit room locked" },
      { key: "v96", label: "Cellar door locked" },
      { key: "v97", label: "Cellar clean" },
      { key: "v98", label: "Correct temperature" },
      { key: "v99", label: "Line clean record complete" },
      { key: "v100", label: "Gas cyclinders chained up" },
      { key: "v101", label: "Stocks off of floor" },
      { key: "v102", label: "Stock in correct positions" },
      { key: "v103", label: "Cellar mate active" },
      { key: "v104", label: "Ice Machines working" },
      { key: "v105", label: "Bag-in-Box clean" },
      { key: "v106", label: "Stock at correct levels" },
      { key: "v107", label: "All in date" },
      { key: "v108", label: "Empty barrels, actually empty" },
      { key: "v109", label: "No unauthorised stock" },
      { key: "v110", label: "Empty barrels stacked" },
    ],
  },
];

export default {
  id: "Arias-Freeze-audit-v1",
  venueId: "Arias-Freeze",
  label: "Arias Freeze",
  sectionList: [
    ...venueSections.map((section) => ({
      ...section,
      items: section.items.map((item) => ({ ...item })),
    })),
    buildManagersOfficeSection(),
  ],
};